import React from 'react';
import PropTypes from 'prop-types';

function FbSticker({ stickerUrl }) {
  return <img className="fbSticker" src={stickerUrl} />;
}

FbSticker.propTypes = {
  stickerUrl: PropTypes.string.isRequired,
};

export default FbSticker;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/conversation_history/conversation_items_v2/facebook/attachments/fb_sticker.jsx